import React from 'react';
import { format } from 'date-fns';
import { Grid } from '@material-ui/core';
import getFullNameByLang from '../langHelpers';
import { efesError } from '../../theme';
import Currency from '../../components/Currency';
import { DEFAULT_CURRENCY } from '../../config';

export const bindContractSummary = (
  totalDiscount,
  totalPrice,
  translate,
  paymentFrequency,
  isFetchingPrice,
  insuredPeople,
  classes,
  language,
  handleOpenInsuredPeopleModal,
) => [
  {
    ...(insuredPeople
        && insuredPeople.length && {
      label: translate('contract.summaryFields.insuredPeople'),
      value: (
        <div className={classes.travelers}>
          {getFullNameByLang(insuredPeople[0], language)}
          {insuredPeople.length > 1 && (
          <span
            onClick={handleOpenInsuredPeopleModal}
            role="presentation"
            className={classes.travelersCount}
          >
            {' '}
            (+
            {insuredPeople.length - 1}
            )
          </span>
          )}
        </div>
      ),
    }),
  },
  {
    label: translate('contract.summaryFields.totalPrice'),
    value: (
      <Grid container justifyContent="flex-end">
        <div>
          <Currency
            value={totalPrice}
            withSymbol
            currency={DEFAULT_CURRENCY}
            isFetching={isFetchingPrice}
          />
        </div>
      </Grid>
    ),
  },
  {
    label: translate('contract.summaryFields.discount'),
    value: (
      <Grid container justifyContent="flex-end">
        <div style={{ color: efesError }}>
          <Currency
            value={totalDiscount}
            withSymbol
            currency={DEFAULT_CURRENCY}
            isFetching={isFetchingPrice}
          />
        </div>
      </Grid>
    ),
  },
  {
    label: translate('contract.summaryTotal'),
    value: (
      <Grid container justifyContent="flex-end">
        <div>
          <Currency
            value={totalPrice - totalDiscount}
            withSymbol
            currency={DEFAULT_CURRENCY}
            isFetching={isFetchingPrice}
          />
        </div>
      </Grid>
    ),
  },
  {
    label: translate('contract.summaryFields.frequency'),
    value: (
      <Grid container justifyContent="flex-end">
        <div>
          {translate(paymentFrequency.translationPath)}
        </div>
      </Grid>
    ),
  },
];

export const bindSummaryContractData = (
  t,
  range,
  riskAmount,
) => [
  {
    label: t('contract.summaryFields.type'),
    value: (
      <div style={{ fontSize: 12 }}>
        {t('oncoCareCalculator.invasiveCancer')}
        <br />
        {t('oncoCareCalculator.preInvasiveCancer')}
        <br />
        {t('oncoCareCalculator.brainCancer')}
        <br />
        {t('oncoCareCalculator.medicalOpinion')}
      </div>
    ),
  },
  {
    label: t('contract.summaryFields.startDate'),
    value: (
    // eslint-disable-next-line no-restricted-globals
      <div>{range.start && !isNaN(range.start) ? format(range.start, 'dd/MM/yyyy') : '-'}</div>
    ),
  },
  {
    label: t('contract.summaryFields.endDate'),
    // eslint-disable-next-line no-restricted-globals
    value: <div>{range.end && !isNaN(range.end) ? format(range.end, 'dd/MM/yyyy') : '-'}</div>,
  },
  {
    label: t('contract.summaryFields.riskAmount'),
    // eslint-disable-next-line no-restricted-globals
    value:
  <Currency
    value={riskAmount}
    withSymbol
    currency={DEFAULT_CURRENCY}
  />,
  },
];
